/** ----------------------------------------
    App routes
 ---------------------------------------- */

import auth from '@middleware/auth';

const routes = [
    {
        path: '/dashboard',
        redirect: '/projects',
        meta: {
            middleware: [auth],
            reqAuth: true,
        },
        component: () => import('@view/templates/Dashboard.vue'),
        children: [
            {
                path: '/projects',
                name: 'projects',
                component: () => import('@view/templates/dashboard/Projects.vue'),
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('@view/templates/dashboard/Profile.vue'),
            },
            {
                path: '/notifications',
                name: 'notifications',
                component: () => import('@view/templates/dashboard/Notifications.vue'),
            },
            {
                path: '/project/:id/:actionId/:actionName',
                name: 'project.action',
                component: () => import('@view/templates/dashboard/ProjectAction.vue'),
            },
            {
                path: '/organisation/:id',
                name: 'organisation',
                component: () => import('@view/templates/dashboard/Organisation.vue'),
            },
            {
                path: '*',
            },
        ],
    }
];

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

export default routes;
